import { useState } from "react";
import { Loader2 } from "lucide-react";
import { upcomingHolidays } from "@/components/TimetableSection";
import { trackEvent } from "@/utils/analytics";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const FIELD = "w-full bg-gray-100 rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#D4A857]/50 text-gray-800";

export default function ChatReminderForm({ onDone }) {
  const [form, setForm] = useState({ parent_name: "", email: "", child_age: "", holidays: [] });
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  const update = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  const toggle = (name) =>
    setForm((f) => ({ ...f, holidays: f.holidays.includes(name) ? f.holidays.filter((h) => h !== name) : [...f.holidays, name] }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.holidays.length === 0) return setError("Please tick at least one holiday.");
    setSending(true);
    setError("");
    try {
      const res = await fetch(`${BACKEND_URL}/api/reminders`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, child_age: Number(form.child_age) }),
      });
      if (!res.ok) throw new Error();
      trackEvent("reminder_signup", "chat: " + form.holidays.join(", "));
      onDone(form.parent_name.trim(), form.holidays);
    } catch {
      setError("Please check your details and try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="bg-white border border-[#D4A857]/40 rounded-2xl p-3 space-y-2 w-full" data-testid="chat-reminder-form">
      <input name="parent_name" required placeholder="Parent name" value={form.parent_name} onChange={update} className={FIELD} data-testid="chat-reminder-name" />
      <input name="email" type="email" required placeholder="Email" value={form.email} onChange={update} className={FIELD} data-testid="chat-reminder-email" />
      <input name="child_age" type="number" min={3} max={18} required placeholder="Child's age" value={form.child_age} onChange={update} className={FIELD} data-testid="chat-reminder-age" />
      <p className="text-xs font-bold text-[#0A1A2F] pt-1">Which holidays?</p>
      <div className="flex flex-wrap gap-1.5">
        {upcomingHolidays.map((h, i) => (
          <button
            type="button"
            key={h.name}
            onClick={() => toggle(h.name)}
            className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${form.holidays.includes(h.name) ? "bg-[#D4A857] border-[#D4A857] text-[#0A1A2F] font-bold" : "border-gray-300 text-gray-600 hover:border-[#D4A857]"}`}
            data-testid={`chat-reminder-holiday-${i}`}
          >
            {h.name}
          </button>
        ))}
      </div>
      {error && <p className="text-xs text-red-600" data-testid="chat-reminder-error">{error}</p>}
      <button
        type="submit"
        disabled={sending}
        className="w-full bg-[#0A1A2F] text-white text-xs font-bold uppercase tracking-wide py-2.5 rounded-lg flex items-center justify-center disabled:opacity-50"
        data-testid="chat-reminder-submit"
      >
        {sending ? <Loader2 size={14} className="animate-spin" /> : "Remind me"}
      </button>
    </form>
  );
}
